import { Container } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import { CreateJobService } from "@application/useCases/job/CreateJobService";
import { IPipelineRepository, IRawFileRepository, IResultsRepository, ISoftwareVersionsRepository, IStorageLocationsRepository, IUserRepository } from "@domain/repositories";
import { JobRepository, LicenseRepository, PipelineRepository, ResultsRepository, SoftwareVersionsRepository, StorageLocationsRepository, UserRepository } from "@infrastructure/repositories";
import { IJobRepository, ISoftwareSettingsRepository } from "@domain/repositories";
import { SoftwareSettingsRepository } from "@infrastructure/repositories/SoftwareSettingsRepository";
import { AuthService, AuthenticatedRequestHandlerService } from "@infrastructure/services";
import { IFastaRepository } from "@domain/repositories/IFastaRepository";
import { FastaRepository } from "@infrastructure/repositories/FastaRepository";
import { UploadFastaService } from "@application/useCases/fasta/UploadFastaService";
import { ListFastaService } from "@application/useCases/fasta/ListFastaService";
import { DeleteFastaService } from "@application/useCases/fasta/DeleteFastaService";
import { DeleteSoftwareSettingsService } from "@application/useCases/softwareSettings/DeleteSoftwareSettingsService";
import { ListJobsService } from "@application/useCases/job/ListJobTasksService";
import { ChangePassword, ListPipelineService } from "@application/useCases";
import { IAuthenticatedRequestHandlerService, IAuthService } from "@application/contracts/services";
import { RawFileRepository } from "@infrastructure/repositories/RawFileRepository";
import { SaveLicenseService } from "@application/useCases/license/SaveLicenseService";
import { ILicenseRepository } from "@domain/repositories/ILicenseRepository";
import { UploadRawFileService } from "@application/useCases/rawFiles/UploadRawFileService";
import { DeleteRawFileService } from "@application/useCases/rawFiles/DeleteRawFileService";
import { UploadLibraryService } from "@application/useCases/library/UploadLibraryService";
import { LibraryRepository } from "@infrastructure/repositories/LibraryRepository";

const createContainer = () => {
  const container = new Container();

  container.bind<CreateJobService>(TYPES.CreateJobService).to(CreateJobService);
  container.bind<IJobRepository>(TYPES.IJobRepository).to(JobRepository);
  container.bind<IPipelineRepository>(TYPES.IPipelineRepository).to(PipelineRepository);
  container.bind<ListPipelineService>(TYPES.ListPipelineService).to(ListPipelineService);
  container.bind<IUserRepository>(TYPES.IUserRepository).to(UserRepository);
  container.bind<ISoftwareSettingsRepository>(TYPES.ISoftwareSettingsRepository).to(SoftwareSettingsRepository);
  container.bind<ISoftwareVersionsRepository>(TYPES.ISoftwareVersionsRepository).to(SoftwareVersionsRepository);
  container.bind<IStorageLocationsRepository>(TYPES.IStorageLocationsRepository).to(StorageLocationsRepository);
  container.bind<IAuthenticatedRequestHandlerService>(TYPES.IAuthenticatedRequestHandlerService).to(AuthenticatedRequestHandlerService);
  container.bind<IFastaRepository>(TYPES.IFastaRepository).to(FastaRepository);
  container.bind<UploadFastaService>(TYPES.UploadFastaService).to(UploadFastaService);
  container.bind<ListFastaService>(TYPES.ListFastaService).to(ListFastaService);
  container.bind<ListJobsService>(TYPES.ListJobsService).to(ListJobsService);
  container.bind<IAuthService>(TYPES.IAuthService).to(AuthService).inSingletonScope();
  container.bind<IRawFileRepository>(TYPES.IRawFileRepository).to(RawFileRepository);
  container.bind<SaveLicenseService>(TYPES.SaveLicenseService).to(SaveLicenseService);
  container.bind<ILicenseRepository>(TYPES.ILicenseRepository).to(LicenseRepository);
  container.bind<IResultsRepository>(TYPES.IResultsRepository).to(ResultsRepository);
  container.bind<ChangePassword>(TYPES.ChangePassword).to(ChangePassword);
  container.bind<DeleteFastaService>(TYPES.DeleteFastaService).to(DeleteFastaService);
  container.bind<DeleteSoftwareSettingsService>(TYPES.DeleteSoftwareSettingsService).to(DeleteSoftwareSettingsService);
  container.bind<UploadRawFileService>(TYPES.UploadRawFileService).to(UploadRawFileService).inSingletonScope();
  container.bind<DeleteRawFileService>(TYPES.DeleteRawFileService).to(DeleteRawFileService);
  container.bind<LibraryRepository>(TYPES.LibraryRepository).to(LibraryRepository);
  container.bind<UploadLibraryService>(TYPES.UploadLibraryService).to(UploadLibraryService);

  return container;
};

const DIContainer = createContainer();

export { DIContainer };
